<template>
  <div class="preloader__wrap">
    <svg width="150" height="150" viewbox="0 0 150 150">
      <path id="border" transform="translate(75, 75)" />
      <path id="loader" transform="translate(75, 75) scale(.84)" />
    </svg>
    <div class="preloader__count">{{ counter }}%</div>
    <div class="preloader__block"></div>
  </div>
</template>

<script>
import gsap from "gsap-3";

export default {
  name: "PreloaderPie",
  data() {
    return {
      counter: 0,
    };
  },
  mounted() {
    //see also https://www.awwwards.com/inspiration/impero-loading-animation
    this.initPie();
    this.initCounter();
    this.onPieDrawn();
  },
  methods: {
    initPie() {
      //base on https://codepen.io/builtonsquares/details/cfjzl
      var loader = document.getElementById("loader"),
        border = document.getElementById("border"),
        α = 0,
        π = Math.PI,
        t = 5;

      (function draw() {
        α += 5;
        if (α == 360) return; //Drow at once
        α %= 360;
        var r = (α * π) / 180,
          x = Math.sin(r) * 75,
          y = Math.cos(r) * -75,
          mid = α > 180 ? 1 : 0,
          anim = "M 0 0 v -75 A 75 75 1 " + mid + " 1 " + x + " " + y + " z";
        //[x,y].forEach(function( d ){
        //  d = Math.round( d * 1e3 ) / 1e3;
        //});

        loader.setAttribute("d", anim);
        border.setAttribute("d", anim);

        setTimeout(draw, t); // Redraw
      })();
    },
    initCounter() {
      let timer = setInterval(() => {
        this.counter += 5;
        if (this.counter == 100) {
          clearInterval(timer);
        }
      }, 20);
    },
    onPieDrawn() {
      gsap
        .timeline()
        .to("svg", 0.3, {
          scale: 1.3,
        })
        .to(
          "svg",
          0.3,
          {
            opacity: 0,
            scale: 0.7,
          },
          "a"
        )
        .to(
          ".preloader__count",
          0.3,
          {
            opacity: 0,
          },
          "a"
        )
        .from(
          ".preloader__block",
          0.2,
          {
            scale: 0,
          },
          "b"
        )
        .to(
          ".preloader__block",
          0.3,
          {
            width: window.matchMedia("(min-width: 768px)").matches
              ? "35%"
              : "60%",
          },
          "b"
        )
        .delay(1);
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/styles/settings.scss";

.preloader {
  &__wrap {
    position: fixed;
    background-color: $b1;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    z-index: 2000;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  &__count {
    color: $o1;
    font-weight: bold;
    font-size: 3rem;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  &__block {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%) skewX(-15deg);
    width: 1%;
    height: 150%;
    background-color: $g1;
    // opacity: 0;
  }
}

svg {
  display: block;
}

#loader {
  fill: $g1;
}

#border {
  fill: $g1;
}
</style>
